
import { mapActions, mapState, mapGetters } from "vuex";
import { ALL_CHANNELS } from "@/constants/Channels.js";
export default {
  data() {
    return {
      isFocused: false,
      search: "",
      result: [],
      searchBy: "token-id",
      searchByOptions: [
        { label: "Order Id", value: "order-id" },
        { label: "Token No", value: "token-id" }
      ]
    };
  },
  computed: {
    ...mapGetters("reciever", ["getChannelAllOrders"])
  },
  mounted() {
    window.addEventListener("keydown", this.focusSearchField);
    this.searchBy = this.$ls.get("searchBy") || "token-id";
  },
  beforeDestroy() {
    window.removeEventListener("keydown", this.focusSearchField);
  },
  watch: {
    search(val) {
      if (val && typeof val === "object") {
        this.handleClick(val.id);
      } else {
        this.result = val
          ? this.getChannelAllOrders(ALL_CHANNELS.name).filter((order) => {
              switch (this.searchBy) {
                case "order-id":
                  return (
                    String(order.merchant_ref_id).indexOf(val) >= 0 ||
                    String(order.partner_order_id).indexOf(val) >= 0
                  );
                case "token-id":
                default:
                  return String(order.token_id).indexOf(val) >= 0;
              }
            })
          : [];
      }
    }
  },
  methods: {
    focusSearchField(e) {
      if (e.keyCode === 114 || (e.ctrlKey && e.keyCode === 70)) {
        e.preventDefault();
        this.$refs["search-reciever"].focus();
      }
    },
    handleClick(id) {
      if (this.$vuetify.breakpoint.mdAndUp) {
        this.$nuxt.$emit("trigger-order-next-action", id);
      } else {
        this.navigateToDetailPage(id);
      }
      this.search = "";
    },
    handleSearchOptionChange() {
      this.$ls.set("searchBy", this.searchBy);
    },
    navigateToDetailPage(id) {
      this.$router.push(`/reciever/${id}`);
    }
  }
};
